import StripePaymentService from '../external/StripePaymentService'
import SupabaseAuthService from '../external/SupabaseAuthService'
import SupabaseDataSource from '../external/SupabaseDataSource'
import SupabaseEdgeFunctionService from '../external/SupabaseEdgeFunctionService'
import SupabaseStorageService from '../external/SupabaseStorageService'
import AuthService from './AuthService'
import DataSource from './DataSource'
import EdgeFunctionService from './EdgeFunctionService'
import NotificationService from './NotificationService'
import PaymentService from './PaymentService'

export const authService: AuthService = new SupabaseAuthService()
export const dataSource: DataSource = new SupabaseDataSource()
export const edgeFunctionService: EdgeFunctionService = new SupabaseEdgeFunctionService()
export const paymentService: PaymentService = new StripePaymentService()
export const notificationService = new NotificationService()
export const storageService = new SupabaseStorageService()
